import angular from 'angular';

module.exports = angular.module('common.directives.inspections', [
    require('./inspection-panel'),
    require('./inspection-repair-item'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inspections/index.js
 **/